module.exports = __webpack_public_path__ + "static-portal/img/new8-2.06fa3e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new8-2.png
// module id = iLZI
// module chunks = 4